export default __webpack_public_path__ + "static/media/job_offer13_m.524fa661.jpg";